<!-- Add back whe text is formatted [ngStyle]="{ color: textColor }" -->
<p
  *ngIf="ready && !visibility.isHidden"
  class="mw568 textContent"
  [ngClass]="{
    firstContent: isFirstPage$ | async
  }"
  [ngStyle]="styles"
  [style.visibility]="visibility.isInvisible ? 'hidden' : 'visible'"
  dir="{{ dir$ | async }}"
>
  <img
    *ngIf="startImgResource"
    [src]="startImgResource"
    [ngStyle]="{ width: startImgWidth }"
    [alt]="text"
  /><span [innerHTML]="textValue"></span>
</p>
